'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('directory-edit', {
      url: '/directory/edit/:name',
      template: '<directory-edit></directory-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/directory/edit/directory-edit.routes.js